import { Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { ClickSignSigner } from '../../../models/ClickSignSigner.model';
import { UserService } from '../../../services/user.service';
import { CommonHelper } from '../../helpers/CommonHelper';
import * as moment from 'moment';
import { ToastsManager } from 'ng2-toastr';
import { SignersClickSignEnum } from '../../enums/signersClickSign';
import { ContractType } from '../../enums/ContractType';

@Component({
    selector: 'signer-modal',
    templateUrl: './signer-modal.component.html',
    styleUrls: ['./signer-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class SignerModalComponent implements OnInit {
    @ViewChild("btnCloseModalSigners") btnCloseModalSigners: ElementRef;
    @Input() consultantData: any;
    @Input() typeContract: any;
    @Output() consultantAndSignerData: EventEmitter<any> = new EventEmitter();
    documentSigners: ClickSignSigner[] = new Array<ClickSignSigner>();
    dropdownSigners: any;
    dropdownSignersDefault: any;
    selectedUserWithKey: any;
    isUserInList = false;
    isNewSignerFormOpen = false;
    newSignerForm: FormGroup;
    isCpfValid = false;
    signerListLength = new Array();
    hasRepeatedGroups = false;
    generateDocumentType = 0;
    selectedAdditiveToAprove: any;
    loading: boolean;
    user: any;
    cpfPatternSigner = [/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    externalUserRemoved: boolean = false;
    isConsultantPj: boolean = false;
    removedConsultantSignerInContract: boolean = false;
    signerIndex: number;
    signer: ClickSignSigner;

    constructor(private userService: UserService,
        private commonHelper: CommonHelper,
        private toastr: ToastsManager,
        public signersClickSignEnum: SignersClickSignEnum,
        private formBuilder: FormBuilder
    ) { }

    async ngOnInit() {
        this.loading = true;

        this.newSignerForm = this.formBuilder.group({
            name: [null, [Validators.required, Validators.minLength(3)]],
            surname: [null, [Validators.required, Validators.minLength(3)]],
            email: [null, [Validators.email, Validators.required]],
            auths: [null],
            documentation: [null],
            birthday: [null],
            type: [null],
            partnerSigner: false
        });
        this.loading = false;
    }

    async loadSignersForDropdown(): Promise<void> {
        this.dropdownSigners = await this.userService.getAllUsersWithSignerKey();
     }

    async signerAndDocumentModal(additive?: any): Promise<void> {

        this.selectedAdditiveToAprove = additive;
        if(this.isNewSignerFormOpen) {
            this.isNewSignerFormOpen = !this.isNewSignerFormOpen;
        };

       this.documentSigners = [];
       this.removedConsultantSignerInContract = false

       let consultantSignerModel = new ClickSignSigner();
       this.consultantData.documentation = this.consultantData.personal.cpf;
       this.consultantData.birthday = moment(this.consultantData.personal.born, 'DD/MM/YYYY').format("DD/MM/YYYY");
       consultantSignerModel.loadDataForConsultantOrInternalUser(this.consultantData);
       consultantSignerModel.group = 1;
       if(this.consultantData.contract && this.consultantData.contract.kind == 1 && this.consultantData.email)
            consultantSignerModel.email = this.consultantData.email;
       consultantSignerModel.isConsultantInContract = true;
       if(this.consultantData.contract.kind == ContractType.PJ ||
        this.consultantData.contract.kind == ContractType.Outros){
           consultantSignerModel.email = this.consultantData.email;
           this.isConsultantPj = true
        }
       this.documentSigners.push(consultantSignerModel);

       const origin = this.consultantData.isFC ? 'fc' : 'omnik'
       this.dropdownSignersDefault = await this.userService.getAllSignersDefault(this.consultantData.excellenceCenter._id, "consultant");
       this.buildSignersDefault();

       this.loadSignersForDropdown();
       this.updateSignerList();

       this.reorganizeSigners(this.documentSigners, false);

       this.verifyGroups(this.documentSigners);
    }

    async buildSignersDefault() {
      const signersHierarchy = {
        "governance": { sign_as: 'witness', group: 2 },
        "judiciary": { sign_as: 'witness', group: 3 },
        "manager": { sign_as: 'party', group: 4 }
      };

      if(this.dropdownSignersDefault && this.dropdownSignersDefault.length > 0) {
        this.dropdownSignersDefault.forEach(async (signerDefault) => {
            if (signerDefault.type === 'manager') {
                const isConfidentialityContract = this.typeContract === 'confidentiality';
                const shouldSkip = isConfidentialityContract
                    ? !signerDefault.isDefaultSignerConfidentiality
                    : signerDefault.isDefaultSignerConfidentiality;

                if (shouldSkip) return;
            }
            let consultantSignerModel = new ClickSignSigner();
            signerDefault.sign_as = signersHierarchy[signerDefault.type].sign_as;
            signerDefault.group = signersHierarchy[signerDefault.type].group;
            signerDefault.group = signerDefault.type == 'judiciary' && signerDefault.division ? 2 : signerDefault.group; //DESENVOLVIMENTO TEMPORÁRIO
            consultantSignerModel.loadDataForConsultantOrInternalUser(signerDefault);

            this.documentSigners.push(consultantSignerModel);
        });
      }
    }

    reorganizeSigners(signersList: ClickSignSigner[], removeUser = false) {
        const unOrderedSignersList = [...signersList.filter((signer, index) =>  index !== 0)];

        const signersHierarchy = {
            "governance": { sign_as: 'witness', group: 2 },
            "judiciary": { sign_as: 'witness', group: 3 },
            "manager": { sign_as: 'party', group: 4 }
        };
        let orderedSignersList = [...this.documentSigners.splice(0, 1)];
        const listGroupLength = this.signerListLength.length;

        let counter = 1;

        for (let signer of unOrderedSignersList) {
            if (signer && signer.type == 'governance') {
                signer.group = signersHierarchy[signer.type].group > listGroupLength || this.signerTypeExists(signer.type) ?
                signersHierarchy[signer.type].group : ++counter;
                signer.sign_as = signersHierarchy[signer.type].sign_as;

            } else if (signer && signer.type == 'judiciary') {
                signer.group = signersHierarchy[signer.type].group > listGroupLength || this.signerTypeExists(signer.type) ?
                signersHierarchy[signer.type].group : ++counter;
                signer.sign_as = signersHierarchy[signer.type].sign_as;

            } else if (signer && signer.type == 'manager') {
                signer.group = signersHierarchy[signer.type].group >= listGroupLength || this.signerTypeExists(signer.type) ?
                signersHierarchy[signer.type].group : ++counter;
                signer.sign_as = signersHierarchy[signer.type].sign_as;

            } else {
                signer.group = listGroupLength;
                signer.sign_as = 'party';
            }
            const hasJudiciaryAlready = orderedSignersList.some((signer) => signer.type == 'judiciary' && this.signerTypeExists(signer.type))
            if (hasJudiciaryAlready) {
                signer.group = signer.type == 'judiciary' && signer.division ? 3 : signer.group; //DESENVOLVIMENTO TEMPORÁRIO
            } else {
                signer.group = signer.type == 'judiciary' && signer.division ? 2 : signer.group; //DESENVOLVIMENTO TEMPORÁRIO
            }

            orderedSignersList.push(signer);
        }

        if (removeUser) {
            orderedSignersList = this.organizeAndAssignRoles(orderedSignersList);
        };

        const sortedList = orderedSignersList.sort((a: any, b: any) => a.group - b.group);
        this.documentSigners = [...sortedList];
    }

    organizeAndAssignRoles(source: ClickSignSigner[]): ClickSignSigner[] {
        const managerCountInList = source.filter(signer => signer.type == 'manager').length;
        const judiciaryCountInList = source.filter(signer => signer.type == 'judiciary').length;
        const governanceCountInList = source.filter(signer => signer.type == 'governance').length;

        return source.map((signer: ClickSignSigner, index: number) => {
            if (signer && signer.group) {
                const isJudiciary = signer.type == 'judiciary';
                const isManager = signer.type == 'manager';
                const isGovernance = signer.type == 'governance';

                let {group} = signer;
                return {
                    ...signer,
                    group: group == 1 ? group
                    : isManager && judiciaryCountInList == 0 && governanceCountInList == 0 && group == 4 ? group - 2
                    : group == 2 && isGovernance && governanceCountInList == 1 ? group
                    : governanceCountInList == 0 ? group - 1
                    : governanceCountInList == 0 && isJudiciary ? group
                    : managerCountInList == 0 && governanceCountInList == 0 && judiciaryCountInList == 2 ? group - 1
                    : isJudiciary && judiciaryCountInList < 2 ? group
                    : isManager && judiciaryCountInList == 1 && governanceCountInList == 1 ? group
                    : managerCountInList == 0 ? group
                    : this.externalUserRemoved ? group
                    : group - 1
                } as ClickSignSigner
            };
        });
    }

    signerTypeExists(type: string) {
        return this.documentSigners.map(signer => signer.type).includes(type);
    }

    async addUserToList(): Promise<void> {
        this.loading = true;
        if (!this.selectedUserWithKey
            || this.selectedUserWithKey.keySigner == undefined) {
            this.loading = false;
            return
        }

        if (this.selectedUserWithKey && this.selectedUserWithKey.username) {
            if(this.verifyUserInList(this.selectedUserWithKey.username)) {
                this.isUserInList = false;
            } else {
                this.isUserInList = true;
                return;
            }
        }

        const userSignerKey = this.selectedUserWithKey.keySigner;
        const userClickSignResponse = await this.userService.getUserInfoWithKeySigner(userSignerKey);
        if (userClickSignResponse == false) {
            this.loading = false;
            this.toastr.error('Usuário escolhido não tem registros no banco de dados ou falha na conexão.', 'Erro no serviço')
            return
        }

        const userClickSignInfo = new ClickSignSigner();

        userClickSignInfo.loadDataForConsultantOrInternalUser(userClickSignResponse);
        userClickSignInfo.birthday = moment(userClickSignInfo.birthday).locale('pt-br').format('DD/MM/YYYY');

        this.documentSigners.push(userClickSignInfo);
        this.toastr.success("Usuário adicionado na lista de signatários.");

        this.updateSignerList();
        this.verifyEmptyGroups();

        this.loading = false;
    }

    changeSignerType(signer: ClickSignSigner): void {
        const newSignerType = signer;
        const userIndex = this.documentSigners.indexOf(newSignerType);
        this.documentSigners[userIndex] = newSignerType;
    }

    setSignerGroup(): void {
        const groups = this.documentSigners.map(groupNumber => groupNumber.group);
        this.verifyGroups(groups);
        if (!this.verifyEmptyGroups()) {
            this.documentSigners = [...this.documentSigners.sort((a, b) => a.group - b.group)]
        };
    }

    updateSignerList(): void {
        this.signerListLength = Array.from({length: this.documentSigners.length}, (x, i) => i+1);
    }

    setNewSignersListOrder(): void {
        const signers = [...this.documentSigners];

        for(let i = 1;i<this.signerListLength.length;i++) {
            signers[i].group = i+1;
        }
        this.documentSigners = [...signers];
    }

    getSigner(index: number, signer: ClickSignSigner) {
        this.signerIndex = index;
        this.signer = signer
        if (!signer.isConsultantInContract) {
            this.removeSignerFromList()
        }
    }

    removeSignerFromList(): void {

        if (this.signer.signerExternal) this.externalUserRemoved = true;
        else this.externalUserRemoved = false;

        if (this.signer.isConsultantInContract) this.removedConsultantSignerInContract = true

        this.documentSigners.splice(this.signerIndex, 1);

        this.setSignerGroup();
        this.updateSignerList();
        this.reorganizeSigners(this.documentSigners, true);
        const groups = this.documentSigners.map(signers => signers.group);
        this.verifyGroups(groups);
    }

    signerFormHandler(): void {
        this.isNewSignerFormOpen = !this.isNewSignerFormOpen;
    }

    trimNewSigner(field: any) {
        if(this.newSignerForm.get(`${field}`).value) {
            const removeWhiteSpace = this.newSignerForm.get(`${field}`).value;
            this.newSignerForm.get(`${field}`).patchValue(removeWhiteSpace.trim());
        }
    }

    verifyNewSignerForm(): boolean {
        return this.newSignerForm.valid ? true : false;
    }

    async verifyNewSignerCPF(signerCpf: any){
        if(!this.commonHelper.cpfValidator(signerCpf)){
            this.toastr.warning("CPF inválido");
            return false;
        } else {
            this.toastr.success("CPF Válido");
            this.isCpfValid = true;
        }
    }

    addNewSignerToList(): void {
        if(this.newSignerForm.valid) {
            this.loading = true;
            const newSigner = new ClickSignSigner();
            newSigner.loadDataForConsultantOrInternalUser(this.newSignerForm.value);
            newSigner.signerExternal = true;
            if (this.verifyUserInList(newSigner.email)) {
                if(this.newSignerForm.get('partnerSigner').value){
                    newSigner.isConsultantInContract = true
                    newSigner.group = 1
                    this.documentSigners.unshift(newSigner)
                    this.removedConsultantSignerInContract = false
                }else{
                    this.documentSigners.push(newSigner);
                }
                this.toastr.success("Usuário adicionado na lista de signatários.");

                this.resetNewSignerForm();
                this.signerFormHandler();
                this.updateSignerList();

            } else {
                this.toastr.warning("Preencha todo o formulário para incluir um novo signatário.", "Erro de cadastro!");
            }
        }
        this.setSignerGroup();
        this.loading = false;
    }

    resetNewSignerForm(): void {
        this.newSignerForm.reset();
    }

    verifyUserInList(signerEmail: string): boolean {
        const userEmailInList = this.documentSigners.find(user => (user.email && user.email.toLowerCase()) == signerEmail.toLowerCase())

        if(userEmailInList == undefined) {
            return true;
        } else {
            this.toastr.error("Não é possível adicionar um usuário que já existe na lista.", "Usuário já existe!");
            return false;
        }
    }

    verifyEmptyGroups(): boolean {
        let hasEmptyGroup = false;
        this.documentSigners.forEach((signer, index) => {
            if(signer.group == 0 && index !== 0) {
                hasEmptyGroup = true;
            }
        })
        return hasEmptyGroup;
    }

    verifyGroups(source: any[]): void {
        this.hasRepeatedGroups = false;
        const sortedArray = source.slice().sort((a: number, b: number) => a - b);
        for (let i = 0; i < sortedArray.length - 1; i++) {
            const nextInTheList = sortedArray[i + 1];
            const consultantInList = this.documentSigners[0].group;
            if (nextInTheList == consultantInList) {
                this.hasRepeatedGroups = true;
                this.toastr.error('Grupos de assinaturas iguais ao consultor não serão permitidas, ordene corretamente!',
                    'ORDEM DE ASSINATURAS', { timeOut: 5000 })
                return;
            } else {
                this.hasRepeatedGroups = false;
            }
        }
    }

    verifyDate2(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultantData[`${field}`] = "";
        }
    }

    async generateDocument(): Promise<void> {
        if(this.invalidSignersListStructure()) {
            this.toastr.warning(
                `A lista deve conter 4 ou 5 signatários, quanto este for Termo de confidencialidade, na estrutura: 1º - Parte / 2º - Testemunha / 3º - Testemunha / 4º - Parte / 5º - Parte`,
                "Lista de signatários inválida"
            );
        } else if (this.typeContract == 'confidentiality' && this.documentSigners.length != 4) {
            this.toastr.warning(
                `Para a geração de Termo de confidencialidade, é obrigatório a seleção de 4 signatários`,
                "Lista de signatários inválida"
            );
        } else {
            this.loading = true;
            this.verifyGroups(this.documentSigners);
            this.documentSigners.sort((a,b) => a.type.localeCompare(b.type));
            const arraySigners = this.documentSigners.map(signer => {
                return {
                 "key": signer.key,
                 "sign_as":  signer.sign_as,
                 "signerExternal": signer.signerExternal,
                 "group": signer.group,
                 "email": signer.email,
                 "name": signer.name,
                 "documentation": signer.documentation,
                 "birthday": signer.birthday
                }
             });
             const signersToDocument = {
                 signers: arraySigners
            }
            Object.assign(this.consultantData, signersToDocument);
            this.signerFormHandler();
            this.consultantAndSignerData.emit(this.consultantData);
            this.btnCloseModalSigners.nativeElement.click();
            this.loading = false;
        }
    }

    invalidSignersListStructure(): boolean {
        const amountDocumentSigners = this.documentSigners.length;
        if(amountDocumentSigners < 4 || amountDocumentSigners > 5)
            return true;
        if(!([this.documentSigners[0].sign_as, this.documentSigners[3].sign_as].every(s => s == 'party')) ||
           !([this.documentSigners[1].sign_as, this.documentSigners[2].sign_as].every(s => s == 'witness')))
            return true;
        if(amountDocumentSigners == 5 && this.documentSigners[4].sign_as != 'party')
            return true;
        return false;
    }

    transcriptUserType(userType: string) {
        switch(userType) {
            case 'governance':
                return 'Governança';
            case 'judiciary':
                return 'Jurídico';
            case 'manager':
                return 'Gestor';
            case 'rs':
                return 'R&S';
            default:
                return 'Sem registro';
        }
    }

    setSignerPartner(target: boolean) {
        this.newSignerForm.get('partnerSigner').setValue(target);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/signer-modal/signer-modal.component.ts